import PaymentMethodSelector from 'yinzhilv-js-sdk/frontend/common-project/component/yinzhilv/payment-method-selector/1.0.16/index.vue';
import orderDetail from '@/lib/data-service/default/wallet_order_orderDetail'
import accountRecharge from '@/lib/data-service/default/wallet_pay_accountRecharge'
import paymentCallback from '@/lib/data-service/default/web_credit_refundNotify'
import QRCode from 'qrcode';
export default {
    data() {
        return {
            detail: {
            },
            loading: false,
            info: {
                title: '',
                show: false,
                url: ''
            }
        }
    },
    components: {
        PaymentMethodSelector,
    },
    methods: {
        newPaySubmit(val) {
            const __this = this;
            const _data = {
                companyId: val.companyId,
                orderNo: val.orderNo,//订单编号
                orderAmount: val.dealAmount,
            }
            __this.$refs.aPaymentMethodSelector.init({
                //     situationParameter: {
                //         "000": {
                //             subject: "用户充值",
                //             orderAmount: __this.detail.dealAmount,
                //             count_down: {
                //                 enable: false
                //             }
                //         }
                //     },
                //     before_pay_event_handler() {
                //         let code = __this.$refs.aPaymentMethodSelector.$refs.aSituation000.payment_channel_code_other
                //         if (code == 6) {
                //             __this.$message({ type: 'warning', message: "请选择支付方式！" })
                //             return Promise.reject("error!");
                //         }
                //         __this.loading = true
                //         return __this.submit(code).then(res => {
                //             __this.loading = false
                //             console.log(res)
                //             switch (code) {
                //                 case 5:
                //                     window.open(res.htmlStr)
                //                     __this.payCallback(res.outTradeNo)
                //                     break;
                //                 case 3:
                //                 case 7:
                //                 case 8:
                //                     let EBank = 'https://lcg.murongtech.com/bhdep/payTransactionNew';
                //                     let personBank = 'https://payment.chinapay.com/CTITS/service/rest/page/nref/000000000017/0/0/0/0/0'
                //                     let action = code == 3 ? EBank : personBank
                //                     let { href } = __this.$router.resolve({
                //                         name: "air-pay-page",
                //                         query: { data: JSON.stringify(res.resultMap), action: action }
                //                     });
                //                     window.open(href, "_blank")
                //                     __this.payCallback(res.outTradeNo)
                //                     break;
                //                 case 1:
                //                 case 2:
                //                     //支付宝微信支付
                //                     const resultMap = res.resultMap;
                //                     const ALIPAY = code == 1 ? resultMap.WECHAT : resultMap.ALIPAY;
                //                     __this.info.title = code == 1 ? '请打开微信扫码本二维码' : '请打开支付宝扫码本二维码'
                //                     QRCode.toDataURL(ALIPAY).then(function (url) {
                //                         // __this.getCode(title, url)
                //                         __this.info.show = true
                //                         __this.info.url = url
                //                         console.log(__this.info)
                //                         __this.payCallback(res.outTradeNo)
                //                     });
                //                     break;
                //                 default:
                //                     break;

                //             }
                //             return Promise.reject("error!");
                //         }).catch(() => {
                //             __this.loading = false
                //             return Promise.reject("error!");
                //         })
                //     },
                situationParameter: {
                    '200': _data
                },

                //支付成功事件处理方法
                pay_successful_event_handler() {
                    __this.info.show = false
                    __this.$router.push({ name: 'distributor-account-message', query: { type: 0 } })
                },
                //支付失败事件处理方法
                pay_failed_event_handler() {
                    __this.info.show = false
                    __this.$router.push({ name: 'distributor-account-message', query: { type: 1 } })
                },
            });
        },
        submit(code) {
            let data = {
                orderNo: this.detail.orderNo,
                totalFee: this.detail.dealAmount,
                paymentChannel: code
            }
            return accountRecharge(data)
        },
        payCallback(tradeNo) {
            let _times = setInterval(() => {
                paymentCallback({ tradeNo }).then(res => {
                    if (res.paymentStatus == 2) {
                        clearInterval(_times)
                        this.info.show = false
                        this.$router.push({ name: 'distributor-account-message', query: { type: 0 } })
                    } else if (res.paymentStatus == 3 || res.paymentStatus == 4) {
                        clearInterval(_times)
                        this.$router.push({ name: 'distributor-account-message', query: { type: 1 } })
                    }
                    setTimeout(() => {
                        clearInterval(_times)
                    }, 1000 * 300)
                })
            }, 3000)
        },
        getCode(title, url) {
            const h = this.$createElement;
            this.$msgbox({
                title: title,
                message: h('div', { style: 'display:flex;justify-content: center;' }, [
                    h('img', { style: 'width:300px;height:300px;', attrs: { src: url } })
                ]),
                showCancelButton: false,
                showConfirmButton: false,
                closeOnClickModal: false
            }).then(action => {
            });
        },
        async getDetail() {
            let orderId = this.$route.query.orderId
            let res = await orderDetail({ orderId })
            this.detail = res
            this.newPaySubmit(res)
        }
    },
    activated() {
        this.getDetail()
        this.$nextTick(() => {
            let btn = document.querySelector('.button-container button')
            btn.innerHTML = '确认充值'
        })
    },

}
